module.exports = __webpack_public_path__ + "assets/images/pages/fundivisa/fundivisa-header.png?64413e76";